<template>
  <div>
    <v-container fluid pa-0 class="fill-height" style="min-height: 500px;">
        <!-- <div class="content pa-lg-16 pa-8">
            <div class="display-1 mb-3 white--text font-weight-bold">
            Tentang Kami
            </div>
            <div class="subtitle-1 white--text">
                Potensi masjid sesungguhnya sangat besar, Masjid pada hakikatnya dapat menjadi pusat peradaban. Dengan hadirnya teknologi, dapat mengeluarkan potensi masjid dengan lebih maksimal.<br> 
                MosQu hadir sebagai platform masjid online dapat menjadi solusi digitalisasi masjid, sehingga segala informasi mengenai masjid menjadi lebih mudah diakses. Mulai dari informasi umum masjid, keuangan, jadwal kajian, hingga donasi online.<br> 
                Platform ini juga mempermudah pengurus masjid untuk melakukan manajemen masjid, seperti manajemen keuangan, kegiatan, dan juga jama’ah.
            </div>
        </div> -->
        <v-img src="@/assets/landingAbout.png" />
    </v-container>
  </div>
</template>
<script>
    export default {
        
    }
</script>
